import { platforms } from '@/mocks/platforms';
import PlatformCard from '@/components/feature/PlatformCard';

export default function FeaturedPlatforms() {
  const featured = platforms.filter((p) => p.isFeatured);

  return (
    <section className="bg-background-100/60 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            精选推荐平台
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            经过多维度严格评测，为你精选最值得使用的免费正版影视平台
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop="">
          {featured.map((platform) => (
            <PlatformCard key={platform.id} {...platform} />
          ))}
        </div>
      </div>
    </section>
  );
}